import React, {useEffect, useRef} from "react";
import TopImage from "../../../assets/images/genius_bestemming.svg";
import FloatingImage from "../../../assets/images/top-section-floating-image.svg";
import AeroplaneBed from "../../../assets/images/icons/aroplane-bed.svg";
import "./style.scss";
import useTranslationCustom from "../../../i18n/customHook/useTranslation";
import ChatWizard from "../../ChatWizard/ChatWizard";
import {useDispatch, useSelector} from "react-redux";
import {getChatBotData, updateQuestionState} from "../../../redux/slices/chatBotSlice";
import {initialQuestionState} from "../../ChatWizard/chatHelpers";
import {isMobile} from "react-device-detect";
import img1 from "../../../assets/images/mobile-chat-bg.JPG";
import img2 from "../../../assets/images/header-image-2.jpg";
import img3 from "../../../assets/images/header-image-3.jpg";
import img4 from "../../../assets/images/header-image-4.jpg";
import img5 from "../../../assets/images/header-image-5.jpg";
import PropTypes from "prop-types";
import { getSearchFilters } from "../../../redux/slices/searchFilterSlice";
import { getLoginConfig } from "../../../redux/slices/loginconfigSlice";
import moment from "moment";
import "moment/locale/nl"; // Import Dutch locale for moment.js
import { resetChatGPTOffers } from "../../../redux/slices/appconfigSlice";

const headerImages = [img1, img2, img3, img4, img5];

const TopSection = ({chatShouldInitiate = false}) => {
    const {T} = useTranslationCustom();
    const dispatch = useDispatch();
    const {GPTChat, questionState, chatTransactionId} = useSelector(getChatBotData);
    const {gptFilters} = useSelector(getSearchFilters);
    const loginConfig = useSelector(getLoginConfig);

    const indexRef = useRef(0);

    // useRef to reference DOM section
    const sectionRef = useRef(null);

    useEffect(() => {
        if (isMobile) {
            const timer = setInterval(() => {
                indexRef.current = (indexRef.current + 1) % headerImages.length;

                // 🔥 Update CSS variable directly without re-render
                if (sectionRef.current) {
                    sectionRef.current.style.setProperty(
                        "--chat-bg",
                        `url(${headerImages[indexRef.current]})`
                    );
                }
            }, 7000);

            return () => clearInterval(timer);
        }
    }, []);

    useEffect(() => {
        if (questionState.length === 0 && GPTChat.length === 0) {
            // Normalize gptFilters.leaveTime with current locale before initializing
            const normalizedFilters = { ...gptFilters };
            if (gptFilters?.leaveTime && loginConfig?.locale?.code) {
                const momentLocale = loginConfig.locale.code.split('_')[0].toLowerCase();
                
                // Try parsing with current locale first, then fallback to English
                let parsedDate = moment(gptFilters.leaveTime, ["DD MMMM YYYY", "DD MMMM", "MMMM DD YYYY", "MMMM DD", moment.ISO_8601], momentLocale);
                
                if (!parsedDate.isValid()) {
                    // Try parsing with English locale if current locale fails
                    parsedDate = moment(gptFilters.leaveTime, ["DD MMMM YYYY", "DD MMMM", "MMMM DD YYYY", "MMMM DD", moment.ISO_8601], 'en');
                }
                
                if (parsedDate.isValid()) {
                    normalizedFilters.leaveTime = parsedDate.locale(momentLocale).format("DD MMMM YYYY");
                }
            }
            dispatch(resetChatGPTOffers());
            dispatch(updateQuestionState(initialQuestionState(T, normalizedFilters)));
        }
    }, [chatTransactionId, questionState, chatShouldInitiate]);

    return (
        <section
            ref={sectionRef}
            id="top-section"
            className="top-section-wrapper"
            style={{
                "--chat-bg": `url(${headerImages[0]})` // initial background
            }}
        >
            <div className="container">
                <div className="content-wrapper d-flex">
                    <div className="image-holder">
                        <img src={TopImage} alt={'top-img'}/>
                    </div>

                    <img src={FloatingImage} className="floating-image" alt={'floating-image'}/>

                    <div className="content-hodler">
                        <h6 className="subtitle heading fs-17 white-text font-noto">
                            <img src={AeroplaneBed} alt={'aeroplane'}/>
                            {T("Home:Home_Hotel_Incl_Flight").toUpperCase()}
                        </h6>

                        <h1 className="heaidng white-text bold font-noto">
                            {/* {T("Home:Home_Explore_Globe")}  Not in use {T("Home:Home_Explore_Globe")} */}
                            {T("Home:Home_Explore_Globe_Mobile")}
                        </h1>

                        <p className="white-text heading-text fs-22 font-noto ">
                            {T("Home:Home_Find_And_Book_Text")}
                        </p>

                        <p className="white-text heading-text fs-22 font-noto top-txt-mobile-only mobile-only">
                            {T("Home:Home_Explore_Globe_Mobile")}
                        </p>
                    </div>
                </div>
            </div>

            <ChatWizard hidden={!chatShouldInitiate && questionState.length > 0}/>
        </section>
    );
};

TopSection.propTypes = {
    chatShouldInitiate: PropTypes.bool
}

export default React.memo(TopSection);
